/**
 * Utilitários de Markdown compartilhados entre a página de leitura do blog
 * e o editor do painel. Mantém a geração de IDs de heading sincronizada com
 * o índice lateral (TableOfContents).
 */

/**
 * Converte um texto de heading em um slug estável usado como `id` da âncora.
 * Idêntico ao antigo `toAnchorId` da página de post para preservar links.
 */
export function toAnchorId(text = "") {
    return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/[\s_]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
}

/**
 * Extrai os headings de nível 2 e 3 (Markdown `## ` / `### `) do conteúdo bruto
 * para alimentar o índice do artigo. Retorna `[{ id, text, level }]`.
 *
 * Linhas dentro de blocos de código (``` ... ```) são ignoradas para não
 * confundir comentários `#` com headings.
 */
export function extractHeadings(rawContent = "") {
    if (!rawContent) return [];

    const headings = [];
    let inCodeFence = false;

    for (const line of rawContent.split(/\r?\n/)) {
        const trimmed = line.trim();

        if (trimmed.startsWith("```")) {
            inCodeFence = !inCodeFence;
            continue;
        }
        if (inCodeFence) continue;

        const match = /^(#{2,3})\s+(.+?)\s*#*$/.exec(trimmed);
        if (!match) continue;

        const level = match[1].length;
        const text = match[2].trim();
        headings.push({ id: toAnchorId(text), text, level });
    }

    return headings;
}
